import jwtDecode from 'jwt-decode'

class UserProfileService {
  constructor() {
    this.amioOicdNamespace = 'https://api.amio.io/'
    this.reinitializeUserProperties()
  }

  reinitializeUserProperties() {
    this.userName = undefined
    this.userEmail = undefined
    this.userId = undefined
    this.isAutomationEnabled = undefined
  }

  getUserName() {
    if (!this.userName) {
      this.userName = _decodeFromJwt(`${this.amioOicdNamespace}name`)
    }
    return this.userName
  }

  getUserEmail() {
    if (!this.userEmail) {
      this.userEmail = _decodeFromJwt(`${this.amioOicdNamespace}email`)
    }
    return this.userEmail
  }

  getUserId() {
    if (!this.userId) {
      this.userId = _decodeFromJwt('sub')
    }
    return this.userId
  }

  getIsAutomationEnabled() {
    if (this.isAutomationEnabled === undefined) {
      this.isAutomationEnabled = _decodeFromJwt(`${this.amioOicdNamespace}isAutomationEnabled`)
    }

    return !!this.isAutomationEnabled
  }
}

function _decodeFromJwt(fieldName) {
  if (!localStorage.access_token) return null

  const decoded = jwtDecode(localStorage.access_token)
  return decoded[fieldName]
}

export default new UserProfileService()
